import { ChevronDown, ChevronUp, CheckCircle2 } from 'lucide-react';

const StepCard = ({ step, isExpanded, onToggle }) => {
  const Icon = step.icon;
  return (
    <div className="mcp-step-card" style={{ '--step-color': step.color }}>
      <button
        className="mcp-step-header"
        onClick={onToggle}
        aria-expanded={isExpanded}
      >
        <div className="mcp-step-header-left">
          <span className="mcp-step-number" style={{ background: step.color }}>
            Step {step.step}
          </span>
          <Icon size={22} style={{ color: step.color, flexShrink: 0 }} />
          <span className="mcp-step-title">{step.title}</span>
        </div>
        {isExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </button>

      {isExpanded && (
        <div className="mcp-step-body">
          <div className="mcp-tags">
            {step.tags.map((tag) => (
              <span key={tag.label} className={`mcp-tag mcp-tag--${tag.type}`}>
                {tag.label}
              </span>
            ))}
          </div>

          <h4 className="mcp-sub-heading">What It Does</h4>
          <ul className="mcp-list">
            {step.description.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>

          <h4 className="mcp-sub-heading">Expected Inputs</h4>
          <div className="mcp-inputs">
            {step.inputs.map((input) => (
              <div key={input.name} className="mcp-input-row">
                <code>{input.name}</code>
                <span>{input.desc}</span>
              </div>
            ))}
          </div>

          <div className="mcp-outputs">
            <h4 className="mcp-sub-heading mcp-sub-heading--output">Output</h4>
            <ul className="mcp-list mcp-list--output">
              {step.outputs.map((item, i) => (
                <li key={i}>
                  <CheckCircle2 size={14} className="mcp-check-icon" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default StepCard;
